import { createContext } from 'react';

// Scoped to a transcript so selections in another pane cannot branch this chat.
export const SideChatContext = createContext(null);
